import { db, auth, firestore } from "@/services/firebase.service";
import store from "@/store";
import { UserService } from "@/services/user.service";
import { downLoadFile } from "@/utils";
import NProgress from "nprogress";

import router from "@/router";

export default {
    setCurrentStep({ commit }, path) {
        commit("SET_CURRENT_STEP", path);
    },

    selectBpi({ commit }, bpi) {
        commit("SELECT_BPI", bpi);

        commit("SET_BP_VERSION", bpi.forms.bpiVersion);
        store.dispatch(
            "ProfilsDesInvestisseurs/putInvestorsData",
            bpi.forms.investors_profiles
        );

        store.dispatch("forms/initSideBar", {
            title: bpi.forms.current_step,
            steeperTitle:
                bpi.forms.current_Substep !== undefined
                    ? bpi.forms.current_Substep
                    : null
        });

        store.dispatch(
            "EtudeDeMarche/putMoyenCommerciaux",
            bpi.forms.moyen_commerciaux
        );
        store.dispatch("VotreProject/putClientsData", bpi.forms.clients_info);

        store.dispatch(
            "VotreProject/putOffersData",

            bpi.forms.offers
        );

        store.dispatch("EtudeTechnique/putITMO", bpi.forms.itmo);

        store.dispatch("VotreProject/putProjectsData", bpi.forms.project_info);

        store.dispatch(
            "VotreProject/putEntreprisesData",
            bpi.forms.entreprise_info
        );

        store.dispatch(
            "EtudeTechnique/putConstructionData",
            bpi.forms.Moyens_fonciers_et_immeubles
        );

        store.dispatch(
            "EtudeTechnique/putTechInstallations",
            bpi.forms.installations_techniques
        );

        store.dispatch(
            "EtudeTechnique/putLabourCard",
            bpi.forms.moyens_humains
        );

        store.dispatch(
            "EtudeTechnique/putTools",
            bpi.forms.materiels_et_outillage
        );

        store.dispatch(
            "EtudeTechnique/putTransportation",
            bpi.forms.moyens_de_transports_et_manutentions
        );

        store.dispatch(
            "EtudeTechnique/putFurnitureCard",
            bpi.forms.mobilier_et_bureaux
        );

        store.dispatch(
            "EtudeTechnique/putTechHardware",
            bpi.forms.materiel_informatique
        );

        store.dispatch(
            "EtudeFinanciere/putInvestment",
            bpi.forms.investors_programme
        );

        store.dispatch(
            "EtudeFinanciere/putCADetails",
            bpi.forms.chiffres_d_affaires_previsionnels
        );
        store.dispatch("EtudeFinanciere/addEvolutionToChiffre", {
            tauxEvolution:
                bpi.forms.chiffres_d_affaires_previsionnels.tauxEvolution,
            tauxRealisation:
                bpi.forms.chiffres_d_affaires_previsionnels.tauxRealisation
        });

        store.dispatch(
            "EtudeFinanciere/putAchatsPrevisionnel",
            bpi.forms.achats_previsionnel
        );

        store.dispatch(
            "EtudeFinanciere/putAutresCharges",
            bpi.forms.autres_charges
        );

        store.dispatch(
            "EtudeFinanciere/putFonctions",
            bpi.forms.charge_du_personnel
        );

        // store.dispatch(
        //   "EtudeTechnique/putConstructionData",
        //   constructionDataProfiles
        // );
    },

    async selectBpiOutPut({ commit }, bpi) {
        commit("SELECT_BPI_OUTPUT", { bpi: bpi.bpi, uid: bpi.uid });
        const bpiOutPut = await db
            .collection(`bpis_output`)
            .doc(bpi.uid)
            .get();

        commit("SET_BPI_OUT_PUT", bpiOutPut.data());
        return bpiOutPut.id;
    },

    AdminSelectBpi({ dispatch }, uid) {
        dispatch("fetchBpi", uid).then(result => {
            if (result === "success") {
                router.push({
                    name: "profils_des_investisseurs",
                    params: { uid: uid }
                });
            }
        });
    },

    selectBpiOutPutFromParams2({ commit }, bpiUID) {
        const promise2 = new Promise(resolve => {
            db.collection(`bpis_output`)
                .doc(bpiUID)
                .get()
                .then(data => {
                    if (data.data() !== undefined) {
                        commit("SET_BPI_OUT_PUT", data.data());
                        resolve(data.data());
                    } else {
                        resolve(null);
                    }
                });
        });
        return promise2;
    },

    selectBpiOutPutFromParams1({ commit }, bpiUID) {
        const promise1 = new Promise(resolve => {
            db.collection(`bpis`)
                .doc(bpiUID)
                .get()
                .then(data => {
                    if (data.data() !== undefined) {
                        commit("SELECT_BPI_OUTPUT", {
                            bpi: data.data(),
                            uid: data.id
                        });
                        resolve(data.data());
                    } else {
                        resolve(null);
                    }
                });
        });

        return promise1;
    },

    async selectPage({ dispatch, state }) {
        if (state.user.bpis.length === 0) {
            return;
        } else {
            try {
                const bpi = await state.user.bpis[0].get();
                dispatch("selectBpi", { forms: bpi.data(), id: bpi.id });
            } catch (error) {
                console.log(error);
            }
        }
    },

    async fetchBpi({ dispatch }, uid) {
        try {
            const bpi = await db
                .collection(`bpis`)
                .doc(uid)
                .get();

            const bpiData = bpi.data();
            if (bpiData !== undefined) {
                dispatch("selectBpi", { forms: bpiData, id: uid });
                return "success";
            } else {
                return "notFound";
            }
        } catch (error) {
            console.log(error);
        }
    },

    setBpiVersion({ commit }, version) {
        commit("SET_BP_VERSION", version);
    },

    async createBPDetailed({ state, commit }) {
        try {
            let docRef;
            if (state.bpiVersion === "Version Détaillée") {
                docRef = await db.collection(`bpis`).add({
                    user: {
                        uid: auth.currentUser.uid,
                        name: state.user.name,
                        cin: state.user.cin
                    },
                    ownerId: auth.currentUser.uid,
                    cin: state.user.cin,
                    Moyens_fonciers_et_immeubles: [],
                    achats_previsionnel: {},
                    autres_charges: {},
                    charge_du_personnel: {},
                    chiffres_d_affaires_previsionnels: {},
                    clients_info: [],
                    entreprise_info: {},
                    installations_techniques: [],
                    investors_profiles: [],
                    investors_programme: {},
                    materiel_informatique: [],
                    materiels_et_outillage: [],
                    mobilier_et_bureaux: [],
                    moyen_commerciaux: {},
                    moyens_de_transports_et_manutentions: [],
                    moyens_humains: [],
                    offers: [],
                    project_info: {},
                    itmo: [],
                    validation: false,
                    ValidationDate: null,
                    current_step: "Profils des investisseurs",
                    bpiVersion: "Version Détaillée"
                });
            } else {
                docRef = await db.collection(`bpis`).add({
                    user: {
                        uid: auth.currentUser.uid,
                        name: state.user.name,
                        cin: state.user.cin
                    },
                    ownerId: auth.currentUser.uid,
                    cin: state.user.cin,
                    Moyens_fonciers_et_immeubles: [],
                    charges_previsionnels: {},
                    chiffres_d_affaires_previsionnels: {},
                    clients_info: [],
                    entreprise_info: {},
                    installations_techniques: [],
                    investors_profiles: [],
                    investors_programme: {},
                    materiel_informatique: [],
                    materiels_et_outillage: [],
                    mobilier_et_bureaux: [],
                    itmo: [],
                    moyens_de_transports_et_manutentions: [],
                    moyens_humains: [],
                    offers: [],
                    project_info: {},
                    validation: false,
                    ValidationDate: null,
                    current_step: "Profils des investisseurs",
                    bpiVersion: "Version Simplifiée"
                });
            }

            await db
                .collection("users")
                .doc(auth.currentUser.uid)
                .update({ bpis: firestore.FieldValue.arrayUnion(docRef) });
            commit("SET_BPI_ID", docRef.id);
            store.dispatch("user/fetchUser", auth.currentUser.uid);
            router.push({
                name: "profils_des_investisseurs",
                params: { uid: docRef.id }
            });
        } catch (error) {
            console.log(error);
        }
    },

    async validation({ getters, rootState }) {
        try {
            NProgress.start();
            let response;
            if (getters.isSimplifiedVersion) {
                response = await UserService.calcBpiOutPutVersionSimplify({
                    bpiId: rootState.user.bpiId
                });
            } else {
                response = await UserService.calcBpiOutPut({
                    bpiId: rootState.user.bpiId
                });
            }

            if (response.status === 200) {
                NProgress.done();
                await db
                    .collection(`bpis`)
                    .doc(`${rootState.user.bpiId}`)
                    .update({
                        validation: true,
                        ValidationDate: Date.now(),
                        State:"Nouveau"
                    });
                return true;
            }
        } catch (error) {
            console.log(error);
        }
    },

    async fetchUser({ dispatch, commit }, uid) {
        try {
            const user = await db
                .collection("users")
                .doc(uid)
                .get();
            commit("SELECT_USER", user.data());
            dispatch("selectPage");
            return user.data();
        } catch (error) {
            console.log(error);
        }
    },
    // eslint-disable-next-line
    async downloadBpi({ commit }, bpi) {
        try {
            const response = await UserService.downloadBpi({
                bpiId: bpi.uid
            });

            if (response.status === 200) {
                downLoadFile(response.data, `${bpi.fileName}.pdf`, "pdf");
            }
        } catch (error) {
            console.log(error);
        }
    }
};
